/**
 * @packageDocumentation
 * @category Hook
 */

import { isActiveRoute } from 'BomdisoftComponents/navigation/button/render';
import { type NavigationMenuItem } from 'BomdisoftComponents/types';
import { useCurrentPage } from '@bomdisoft/utilities';

export const useIsActiveMenu = (route: NavigationMenuItem) => isActiveRoute(route, useCurrentPage());
